// services/bridge.js
import { server } from "../utils/server"

export const bridgeTransfer = (from, to, payload) => {
  let url = "";
  from = from.toLowerCase();
  to = to.toLowerCase();

  if (from === "polygon" && to === "algorand") {
    url = "/investor/bridge/polygon-to-algorand";
  } else if (from === "algorand" && to === "polygon") {
    url = "/investor/bridge/algorand-to-polygon";
  } else {
    throw new Error("Unsupported bridge direction");
  }

  return server.post(url, payload)
    .then(res => res.data)
    .catch(err => err?.response?.data);
};

export const getTransactionHistory = async (entityId,listingId = null, rightToOwnerShip )=>{
    return server.get(`/investor/bridge/transactions?entityId=${entityId}&listingId=${listingId}&rightToOwnerShip=${rightToOwnerShip}`)
    .then((res)=>{
        return res.data
    })
    .catch((error)=>{
        return error
    })
  }

export const checkOptin = (data) =>{
    return server.post('/investor/bridge/optin-check', data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

export const quickCheckOptin = (data) =>{
    return server.post('/investor/bridge/quick-optin-check', data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}